import React from "react";
import { Input, Form, Tooltip } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';

interface NumberInputProps {
  inputValue: number;
  setInputValue: (value: number) => void;
  title: string;
  placeholder: string;
  style?: React.CSSProperties;
  required?: boolean;
  rules?: object[];
  name?: string;
  prefix?: React.ReactNode;
  tooltipText?: string;
}

const NumberInput: React.FC<NumberInputProps> = ({
  inputValue,
  setInputValue,
  title,
  placeholder,
  style,
  required = false,
  rules = [],
  name,
  prefix,
  tooltipText,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow numeric input
    const value = e.target.value.replace(/[^\d]/g, '');
    setInputValue(value ? Number(value) : 0);
  };

  const isRequiredEmpty = required && (inputValue === 0 || isNaN(inputValue));

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-1.5">
        <label 
          className="text-sm font-medium text-[#005D6E]"
          htmlFor={name}
        >
          {title} {required && <span className="text-[#75A7AD] ml-0.5">*</span>}
        </label>
        
        {tooltipText && (
          <Tooltip title={tooltipText} placement="right">
            <InfoCircleOutlined 
              className="text-[#75A7AD] cursor-help text-xs"
            />
          </Tooltip>
        )}
      </div>

      <Form.Item
        name={name}
        rules={rules.length ? rules : [{ required, message: `${title} is required` }]}
        className="mb-1"
      >
        <Input
          id={name}
          prefix={prefix}
          className={`rounded-full border-1.8 border-[#75A7AD] ${
            isRequiredEmpty ? "border-red-300" : ""
          }`}
          style={{ 
            height: "44px",
            fontSize: "16px",
            boxShadow: "none",
            ...style
          }}
          value={inputValue === 0 ? "" : inputValue}
          placeholder={placeholder}
          onChange={handleChange}
          type="tel"
          pattern="[0-9]*"
          inputMode="numeric"
        />
      </Form.Item>
    </div>
  );
};

export default NumberInput;